export {default as ManageAccount} from './ManageAccount';



// WEBPACK FOOTER //
// ./src/components/Form/ManageAccount/index.js